import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService } from './api.service';
import { catchError, map, of, switchMap } from 'rxjs';
import { DataService } from './data.service';
import { LoginResponse } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class RouteGuardService implements CanActivate{

  constructor(private apiSerice: ApiService, private router: Router, private dataService: DataService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
      return this.apiSerice.getUserRoleIfTokenValid().pipe(switchMap((userRole: string) => {
        if(userRole){
          // TODO: implement logic to do role check on access token
          return of(this.isUserAllowed(userRole, route))
        } else {
          const refreshToken = this.dataService.getRefreshToken();
          if(refreshToken){
            return this.apiSerice.refreshToken(refreshToken).pipe(map((refreshResp:LoginResponse)=> {
              if (refreshResp?.access_token) {
                this.apiSerice.saveLogin(refreshResp);

                // TODO: implement logic to do role check on new access token
                return this.isUserAllowed(userRole, route);
              } else {
                this.router.navigate(['login'], {queryParams: {returnUrl: state.url}});
                return false;
              }
            }), catchError(()=> {
              this.router.navigate(['login'], {queryParams: {returnUrl: state.url}});
                return of(false);
            }))
          } else {
            this.router.navigate(['login'], {queryParams: {returnUrl: state.url}});
            return of(false);
          }
        }

      }),
       catchError(()=> {
        this.router.navigate(['login'], {queryParams: {returnUrl: state.url}});
          return of(false);
      }));

  }

  isUserAllowed(userRole: string,route:ActivatedRouteSnapshot){
    const allowedRoles:string [] = route.data["roles"]
    return allowedRoles.includes(userRole);
  }


}
